import { VideoAssetBrowser } from './VideoAssetBrowser';

export default VideoAssetBrowser;
